import React, { useEffect } from "react";
import { Empty } from "antd";
import { message } from "../Message";
import styles from "./index.modules.less";

const NoPermission = ({ description = "您没有该模块的访问权限，请联系主账号管理员开通", showToast = true }) => {
  useEffect(() => {
    if (showToast) {
      message.show({
        type: "error",
        content: "您没有该模块的访问权限，请联系主账号管理员开通",
        closeTime: 3000,
      });
    }
  }, [showToast]);

  return (
    <div className={styles.container}>
      <Empty
        description={description}
      />
    </div>
  );
};

export default NoPermission;
